import { PARTICIPANT_ADVOCATE_IMAGE_MAP, PARTICIPANT_NAME_SYSTEM_FRIENDLY } from 'constants/twilio';
import { IconSystemAvatar } from 'components/Icons';
import { htmlId } from 'utils/html';

import {
  StyledAvatarCircle,
  StyledAvatarContainer,
  StyledAvatarImage,
  StyledPresenceCircle,
} from './Avatar.styles';
import { AvatarProps } from './Avatar.types';

const Avatar = ({ participantName, showPresence, size }: AvatarProps) => {
  const backgroundUrl =
    PARTICIPANT_ADVOCATE_IMAGE_MAP[participantName.toLowerCase()] ||
    PARTICIPANT_ADVOCATE_IMAGE_MAP.DEFAULT;

  const isSystem = participantName.toLowerCase() === PARTICIPANT_NAME_SYSTEM_FRIENDLY.toLowerCase();

  return (
    <StyledAvatarContainer id={htmlId('avatar-container')} size={size}>
      {isSystem ? (
        <StyledAvatarCircle id={htmlId('avatar-image')} size={size}>
          <IconSystemAvatar width={size} height={size} />
          {showPresence && <StyledPresenceCircle id={htmlId('presence-circle')} />}
        </StyledAvatarCircle>
      ) : (
        <StyledAvatarImage id={htmlId('avatar-image')} size={size} backgroundUrl={backgroundUrl}>
          {showPresence && <StyledPresenceCircle id={htmlId('presence-circle')} />}
        </StyledAvatarImage>
      )}
    </StyledAvatarContainer>
  );
};

export default Avatar;
